import affiliate_banner_en from '../assets/affiliate/banner_en.webp'
import affiliate_banner_es from '../assets/affiliate/banner_es.webp'
import new_badge_en from '../assets/casino/new_badge_en.webp'
import new_badge_es from '../assets/casino/new_badge_es.webp'
import freespins_en from '../assets/common/freespins_en.gif'
import freespins_es from '../assets/common/freespins_es.gif'
import pwa_step_2_en from '../assets/common/pwa_step_2_en.webp'
import pwa_step_2_es from '../assets/common/pwa_step_2_es.webp'
import freespin_modal_title_en from '../assets/free-spin-modal/freespin_en.webp'
import freespin_modal_title_es from '../assets/free-spin-modal/freespin_es.webp'
import free_spins_banner_en from '../assets/free-spins/free_spins_banner_en.gif'
import free_spins_banner_es from '../assets/free-spins/free_spins_banner_es.gif'
import referral_banner_en from '../assets/referral/banner_en.webp'
import referral_banner_es from '../assets/referral/banner_es.webp'
import referral_pie_graph_en from '../assets/referral/pie_graph_en.webp'
import referral_pie_graph_es from '../assets/referral/pie_graph_es.webp'
import poster_1_en from '../assets/referral/poster_1_en.webp'
import poster_1_es from '../assets/referral/poster_1_es.webp'
import poster_2_en from '../assets/referral/poster_2_en.webp'
import poster_2_es from '../assets/referral/poster_2_es.webp'
import refer_btn_en from '../assets/referral/refer_btn_en.gif'
import refer_btn_es from '../assets/referral/refer_btn_es.gif'
import referral_three_way_illustration_en from '../assets/referral/three_way_illustration_en.webp'
import referral_three_way_illustration_es from '../assets/referral/three_way_illustration_es.webp'
import register_banner_en from '../assets/register/banner_en.webp'
import register_banner_es from '../assets/register/banner_es.webp'
import competition_banner_en from '../assets/register/competition_banner_en.webp'
import competition_banner_es from '../assets/register/competition_banner_es.webp'
import deposit_banner_en from '../assets/register/deposit_banner_en.webp'
import deposit_banner_es from '../assets/register/deposit_banner_es.webp'
import freespins_promo_reg_en from '../assets/register/freespins_promo_reg_en.webp'
import freespins_promo_reg_es from '../assets/register/freespins_promo_reg_es.webp'
import rescue_bonus_en from '../assets/register/rescue_bonus_en.webp'
import rescue_bonus_es from '../assets/register/rescue_bonus_es.webp'

export const IMAGE_TRANSLATIONS = {
  'referral-banner': {
    en: referral_banner_en,
    es: referral_banner_es,
  },
  'affiliate-banner': {
    en: affiliate_banner_en,
    es: affiliate_banner_es,
  },
  'register-banner': {
    en: register_banner_en,
    es: register_banner_es,
  },
  'poster-1': {
    en: poster_1_en,
    es: poster_1_es,
  },
  'poster-2': {
    en: poster_2_en,
    es: poster_2_es,
  },
  'referral-pie-graph': {
    en: referral_pie_graph_en,
    es: referral_pie_graph_es,
  },
  'referral-three-way-illustration': {
    en: referral_three_way_illustration_en,
    es: referral_three_way_illustration_es,
  },
  "freespins": {
    en: freespins_en,
    es: freespins_es,
  },
  'freespin-modal-title': {
    en: freespin_modal_title_en,
    es: freespin_modal_title_es,
  },
  'new-badge': {
    en: new_badge_en,
    es: new_badge_es,
  },
  'free-spins-banner': {
    en: free_spins_banner_en,
    es: free_spins_banner_es,
  },
  'pwa-step-2': {
    en: pwa_step_2_en,
    es: pwa_step_2_es,
  },
  'freespins-promo-reg': {
    en: freespins_promo_reg_en,
    es: freespins_promo_reg_es,
  },
  'deposit-banner': {
    en: deposit_banner_en,
    es: deposit_banner_es,
  },
  'competition-banner': {
    en: competition_banner_en,
    es: competition_banner_es,
  },
  'refer-now': {
    en: refer_btn_en,
    es: refer_btn_es,
  },
  'rescue-bonus': {
    en: rescue_bonus_en,
    es: rescue_bonus_es,
  },
} as const
